module.exports = __webpack_public_path__ + "static/img/荣誉_03@2x.6fcd7420.png";